import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FilterPanelActions } from '../../store/actions';
import { FilterPanelSelectors } from '../../store/selectors';
import { map, switchMap } from 'rxjs/operators';
import { OptionState } from '../../models';
import { DataFilterManagerService } from '../data-filter-manager/data-filter-manager.service';

@Injectable()
export class FilterPanelFacadeService {
  constructor(
    private store: Store,
    private filterManagerService: DataFilterManagerService,
  ) {}

  init(filterInstanceId: string): void {
    this.store.dispatch(FilterPanelActions.init({ filterInstanceId }));
  }

  isOpen(): Observable<boolean> {
    return this.store.pipe(select(FilterPanelSelectors.selectOpenState));
  }

  isInitialized(): Observable<boolean> {
    return this.store.pipe(select(FilterPanelSelectors.selectIsInitialized));
  }

  getCurrentFilterInstanceId(): Observable<string> {
    return this.store.pipe(select(FilterPanelSelectors.selectCurrentInstanceId));
  }

  open(): void {
    this.store.dispatch(FilterPanelActions.open());
  }

  close(destroy?: true): void {
    this.store.dispatch(FilterPanelActions.close({ destroy }));
  }

  isFilterActive(onlyDisplayed = true): Observable<boolean> {
    return this.store.pipe(
      select(FilterPanelSelectors.selectCurrentInstanceId),
      switchMap((filterInstanceId: string) => {
        return this.filterManagerService.getAppliedFilterOptions(filterInstanceId, onlyDisplayed);
      }),
      map((options: OptionState[]) => !!options?.length),
    );
  }
}
